import { render } from "./Footer.vue?vue&type=template&id=70aee1d6&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=70aee1d6&lang=scss&scoped=true"

import exportComponent from "/Users/richardpitul/Projects/booking-calendars/athletics-booking-calendar/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70aee1d6"]])

export default __exports__